module.exports = __webpack_public_path__ + "static/media/fa-brands-400.9d67fa14.svg";